module.exports = __webpack_public_path__ + "img/1528109133.cc0fa9ea.jpg";